import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { fetchUser } from "slices/user";

import "./app.scss";

import Auth from "./pages/Auth";
import Home from "pages/Home";
import PJPView from "pages/PJPView";
import VisistsList from "pages/Visits";

import MasterApp from "./master";
import MasterDashboard from "master/dashboard/MasterDashboard";
import AttendanceView from "pages/Attendance";
import DailyVisit from "pages/Daily Visit";
import TimeSpent from "pages/TimeSpent";
import Sync from "pages/Sync";
import Onboard from "pages/onboard";
import UpdateLoaction from "pages/Update Dealer Location";
import SwitchBeat from "pages/Switch Beat";
import Upload from "pages/Upload";
import AddDocument from "pages/Add Document";
import VisitDownload from "pages/Visits Data Download";
import EditDocument from "pages/Edit Document";
import ProspectusVisits from "pages/Prospectus Visits";
import Tasks from "pages/Tasks";
import Leads from "pages/Leads";
import Dashboard from "pages/Dashboard";
import VisitStats from "pages/Visits Stats";
import TaskStats from "pages/Task Stats";
import { WearNature } from "pages/SE_Journey";
import DealerChurn from "pages/DealerChurn";
import Actyvai from "pages/Actyvai"
import Agreement from "pages/Actyvai/Agreement"
import DealerForm from "pages/Actyvai/DealerForm"
import Holiday from "pages/Holiday";
import DealerDirectory from "pages/DealerDirectory";
import ReimbursementCategory from "pages/ReimbursementCategory";
import Reimbursement from "pages/Reimbursements";
import AttendanceData from "pages/Attendance Data";
import ExpenseDashboard from "pages/Expense Dashboard";
import SpendLimit from "pages/Spend limit";
import SchemeScanner from "pages/Scheme Scanner";
import SurevyReconcilation from "pages/Reconcilation";
import MarketResearch from "pages/Market Research";
import DealerHelpDesk from "pages/Dealer Help Desk";
import DealerOnboardForm from "pages/DealerOnboard";
import DealerOnboardPreview from "pages/DealerOnboard/Preview";
// import SchemeScanner from "pages/SchemeScanner";

const App = () => {
  const dispatch = useDispatch();
  const { loading, user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchUser());
  }, []);

  return (
    <div className="app">
      <Router>
        <Switch>
          <Route exact path="/master">
            <MasterApp />
          </Route>

          <Route exact path="/master/dashboard">
            <MasterDashboard />
          </Route>
          <Route exact path="/dashboard">
            {!user?._id ? <Auth /> : <Dashboard />}
          </Route>
          <Route path="/SO/:SAP_ID/PJP">
            {!user?._id ? <Auth /> : <PJPView />}
          </Route>
          <Route exact path="/">
            {!user?._id ? (
              <Auth />
            ) : user?.role === "ZTM" ? (
              <Redirect to="/vists-download" />
            ) : (
              <Home />
            )}
          </Route>
          <Route exact path="/sync">
            {!user?._id ? <Auth /> : <Sync />}
          </Route>
          <Route exact path="/onboard">
            {!user?._id ? <Auth /> : <Onboard />}
          </Route>
          <Route exact path="/visit-stats">
            {!user?._id ? <Auth /> : <VisitStats />}
          </Route>
          <Route exact path="/wear-nature">
            {!user?._id ? <Auth /> : <WearNature />}
          </Route>
          <Route exact path="/task-stats">
            {!user?._id ? <Auth /> : <TaskStats />}
          </Route>
          <Route exact path="/update-location">
            {!user?._id ? <Auth /> : <UpdateLoaction />}
          </Route>
          <Route exact path="/switch-beat">
            {!user?._id ? <Auth /> : <SwitchBeat />}
          </Route>
          <Route exact path="/SO/:SAP_ID/visits">
            {!user?._id ? <Auth /> : <VisistsList />}
          </Route>
          <Route exact path="/SO/:SAP_ID/attendance">
            {!user?._id ? <Auth /> : <AttendanceView />}
          </Route>
          <Route exact path="/SO/:SAP_ID/daily">
            {!user?._id ? <Auth /> : <DailyVisit />}
          </Route>
          <Route exact path="/SO/:SAP_ID/daily/timespent">
            {!user?._id ? <Auth /> : <TimeSpent />}
          </Route>
          <Route exact path="/upload-documents">
            {!user?._id ? <Auth /> : <Upload />}
          </Route>
          <Route exact path="/add-documents">
            {!user?._id ? <Auth /> : <AddDocument />}
          </Route>
          <Route exact path="/vists-download">
            {!user?._id ? <Auth /> : <VisitDownload />}
          </Route>
          <Route exact path="/upload-documents/edit/:id">
            {!user?._id ? <Auth /> : <EditDocument />}
          </Route>
          <Route exact path="/SO/:SAP_ID/prospectus/visits">
            {!user?._id ? <Auth /> : <ProspectusVisits />}
          </Route>
          <Route exact path="/SO/:SAP_ID/tasks">
            {!user?._id ? <Auth /> : <Tasks />}
          </Route>
          <Route exact path="/SO/:SAP_ID/leads">
            {!user?._id ? <Auth /> : <Leads />}
          </Route>
          <Route exact path="/dealer-churn">
            {!user?._id ? <Auth /> : <DealerChurn />}
          </Route>
          <Route exact path="/actyv-ai">
            {!user?._id ? <Auth /> : <Actyvai />}
          </Route>
          <Route exact path="/actyv-ai/dealer-form">
            {!user?._id ? <Auth /> : <DealerOnboardForm />}
          </Route>
          <Route exact path="/actyv-ai/dealer-form/preview">
            {!user?._id ? <Auth /> : <DealerOnboardPreview />}
          </Route>
          <Route exact path="/dealer-help-desk">
            {!user?._id ? <Auth /> : <DealerHelpDesk />}
          </Route>
          <Route exact path="/dealer-agreement/documentId::documentId">
            {<Agreement />}
          </Route>
          <Route exact path="/holiday">
            {!user?._id ? <Auth /> : <Holiday />}
          </Route>
          <Route exact path="/dealer-directory">
            {!user?._id ? <Auth /> : <DealerDirectory />}
          </Route>
          <Route exact path="/reimbursement-category">
            {!user?._id ? <Auth /> : <ReimbursementCategory />}
          </Route>
          <Route exact path="/reimbursement">
            {!user?._id ? <Auth /> : <Reimbursement />}
          </Route>
          <Route exact path="/attendance-data">
            {!user?._id ? <Auth /> : <AttendanceData />}
          </Route>
          <Route exact path="/expense-dash">
            {!user?._id ? <Auth /> : <ExpenseDashboard />}
          </Route>
          <Route exact path="/spend-limit">
            {!user?._id ? <Auth /> : <SpendLimit />}
          </Route>
          <Route exact path="/survey">
            {!user?._id ? <Auth /> : <SchemeScanner />}
          </Route>
          <Route exact path="/survey-reconciliation">
            {!user?._id ? <Auth /> : <SurevyReconcilation />}
          </Route>
          <Route exact path="/market-research">
            {!user?._id ? <Auth /> : <MarketResearch />}
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
